module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-search-pagi"
  }, [_c('div', {
    staticClass: "sd-pagi-wrapper"
  }, [_c('pagination', {
    attrs: {
      "isNext": _vm.isNext,
      "isPrev": _vm.isPrev,
      "showNext": _vm.isJiraNext || _vm.isConfluenceNext,
      "showPrev": _vm.currentPage > 1,
      "next": _vm.next,
      "previous": _vm.previous,
      "loader": _vm.loader
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcbb7b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/childs/SearchPagination.vue
// module id = 424
// module chunks = 1